import React, { useState } from 'react';

// A large, tap-friendly "keycap" button that shows only an arrow glyph and a
// quick tooltip on hover. Used to lay the assessment / practice controls out
// like the arrow keys on a keyboard. Response keys are color-coded so a
// teacher can tell them apart without text labels:
//   incorrect → soft red, correct → soft green, neutral → grey (Back / nav).
const VARIANTS = {
  neutral:   { bg: '#f1f5f9', bgHover: '#e2e8f0', border: '#94a3b8', color: '#334155' },
  incorrect: { bg: '#fee2e2', bgHover: '#fecaca', border: '#ef4444', color: '#b91c1c' },
  correct:   { bg: '#dcfce7', bgHover: '#bbf7d0', border: '#22c55e', color: '#15803d' },
};

function KeyButton({
  glyph,
  tooltip,
  onClick,
  disabled = false,
  variant = 'neutral',
  size = 72,
  ariaLabel,
}) {
  const [hover, setHover] = useState(false);
  const v = VARIANTS[variant] || VARIANTS.neutral;
  const showTip = hover && !disabled && !!tooltip;

  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel || tooltip}
        className="key-button"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onBlur={() => setHover(false)}
        onFocus={() => setHover(true)}
        style={{
          width: size,
          height: size,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '10px',
          border: `1px solid ${disabled ? '#cbd5e1' : v.border}`,
          borderBottomWidth: '4px',
          background: disabled ? '#f8fafc' : (hover ? v.bgHover : v.bg),
          color: disabled ? '#cbd5e1' : v.color,
          fontSize: `${Math.round(size * 0.42)}px`,
          fontWeight: 800,
          lineHeight: 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.4 : 1,
          boxShadow: disabled ? 'none' : 'inset 0 -2px 0 rgba(15,23,42,0.06), 0 2px 4px rgba(15,23,42,0.08)',
          transition: 'background-color 0.12s ease',
          userSelect: 'none',
        }}
      >
        {glyph}
      </button>
      {showTip && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 8px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#1e293b',
            color: '#fff',
            padding: '4px 10px',
            borderRadius: '6px',
            fontSize: '0.8rem',
            fontWeight: 700,
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            zIndex: 50,
          }}
        >
          {tooltip}
          <span
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderWidth: '5px',
              borderStyle: 'solid',
              borderColor: '#1e293b transparent transparent transparent',
            }}
          />
        </span>
      )}
    </div>
  );
}

export default KeyButton;
